module.exports = __webpack_public_path__ + "static/media/heroimage_igib-023.973a3c21.jpg";